// See Design > UI, "Curator Studio assets". Render code as escaped text, never HTML.
export function CodeBlock({ label, code }: { label: string; code: string }) {
  return <figure class="ui-code"><figcaption>{label}</figcaption><pre tabIndex={0}><code>{code}</code></pre></figure>;
}
